export default "__VITE_ASSET__abbbff07__"